import { Text } from '@/_components';
import type { InvoiceQuerySchema } from '@/_pages/invoices/shared/schemas';

import { InvoiceCopyRecipientEmailsButton } from './invoice-copy-recipient-emails-button';

type InvoiceDetailsTabHeaderProps = {
  invoice: InvoiceQuerySchema;
};

/** Company row + copy action — shared at top of General, Detail, and Notes tabs. */
export function InvoiceDetailsTabHeader({ invoice }: InvoiceDetailsTabHeaderProps) {
  return (
    <div>
      <div className="flex items-center justify-between gap-2">
        <Text className="text-c-card-muted text-[10px] font-semibold tracking-wide uppercase">Company</Text>
        <InvoiceCopyRecipientEmailsButton invoice={invoice} />
      </div>
      <div className="border-c-border mt-1 rounded border px-2 py-1.5">
        <Text className="text-c-card-foreground text-sm font-semibold">{invoice.client?.name ?? '—'}</Text>
      </div>
    </div>
  );
}
